/* Base styles for standalone radio inputs */
.gds-radio-input {
  height: var(--radio-button-input-height);
  width: var(--radio-button-input-width);
  border: var(--radio-button-input-border-style);
  background-color: var(--radio-button-container-background-color);
  border-radius: var(--radio-button-input-border-radius);

  -moz-appearance: none;
  -webkit-appearance: none;
  -o-appearance: none;
  margin: 0;
  display: inline-block;
  cursor: pointer;
  position: relative;
  vertical-align: middle;
}

/* Focus styles */
.gds-radio-input:focus-visible {
  outline: var(--focus-outline);
  outline-offset: var(--focus-outline-offset);
}

/* Hover states */
.gds-radio-input:not(:disabled):hover {
    border: var(--radio-button-hover-input-border-style);
}

/* Active (pressed) states */
.gds-radio-input:not(:disabled):active {
  border: var(--radio-button-active-input-border-style);
}

/* Checked states with custom checkmarks */
.gds-radio-input:checked {
  background-color: var(
    --radio-button-selected-input-background-color,
    #ffffff
  );
  border: var(--radio-button-checked-input-border-style);
  position: relative;
}

/* Radio checkmark (inner circle) */
.gds-radio-input:checked::after {
  content: "";
  pointer-events: none;
  position: absolute;
  display: inline-block;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  height: 0.75rem;
  width: 0.75rem;
  border-radius: 50%;
  background-color: var(
    --radio-button-active-container-background-color,
    #3b82f6
  );
}

/* Disabled states */
.gds-radio-input:disabled {
  border: var(--radio-button-disabled-input-border-style);
  background-color: var(
    --radio-button-disabled-container-background-color,
    #f9fafb
  );
  cursor: not-allowed;
  opacity: 0.6;
}

.gds-radio-input:disabled:checked {
  background-color: var(
    --radio-button-disabled-checked-container-background-color,
    #f9fafb
  );
}

.gds-radio-input:disabled:checked::after {
  background-color: var(
    --radio-button-disabled-container-background-color,
    #9ca3af
  );
}

/* Error states */
.gds-radio-input.gds-error,
.gds-radio-input[data-error="true"] {
  border: var(--radio-button-error-input-border-style);
  background-color: var(--radio-button-error-input-background-color);
}

/* Label styling for proper alignment and spacing */
label:has(.gds-radio-input) {
  display: inline-flex;
  align-items: center;
  gap: var(--spacing-s);
  cursor: pointer;
  user-select: none;
}
